import { MediumTypesEnum } from 'src/modules/user-input/calcV100/constants.ts';
import { convert } from 'src/modules/user-input/convert.ts';
import { MediumParamsState } from 'src/modules/user-input/MediumParams/types.ts';
import { Unit } from 'uom';

export type MediumParamsAction = {
    type: 'medium_change';
    payload: { medium: MediumTypesEnum; initialState: MediumParamsState };
}
| { type: 'concentration_change'; payload: string }
| { type: 'density_change'; payload: string }
| { type: 'density_unit'; payload: Unit.Unit<'Density'> }
| { type: 'specificHeatCapacity_change'; payload: string }
| { type: 'specificHeatCapacity_unit'; payload: Unit.Unit<'SpecificHeatCapacity'> }
| { type: 'temperature_change'; payload: number }
| { type: 'reset'; payload: MediumParamsState };

export const reducer = (prevState: MediumParamsState, action: MediumParamsAction): MediumParamsState => {
    if (action.type === 'medium_change') {
        const { medium, initialState } = action.payload;

        return {
            ...initialState,
            medium,
        };
    }
    if (action.type === 'temperature_change') {
        return {
            ...prevState,
            temperature: action.payload,
        };
    }
    if (action.type === 'density_change') {
        return {
            ...prevState,
            density: action.payload,
        };
    }
    if (action.type === 'density_unit') {
        return {
            ...prevState,
            density: convert(
                prevState.density,
                prevState.densityUnit,
                action.payload,
            ),
            densityUnit: action.payload,
        };
    }
    if (action.type === 'specificHeatCapacity_unit') {
        return {
            ...prevState,
            heatCapacity: convert(
                prevState.heatCapacity,
                prevState.heatCapacityUnit,
                action.payload,
            ),
            heatCapacityUnit: action.payload,
        };
    }
    if (action.type === 'specificHeatCapacity_change') {
        return {
            ...prevState,
            heatCapacity: action.payload,
        };
    }
    if (action.type === 'concentration_change') {
        return {
            ...prevState,
            concentration: action.payload,
        };
    }
    if (action.type === 'reset') {
        return { ...action.payload };
    }

    return prevState;
};
